module.exports = __webpack_public_path__ + "static/media/dot.dbce10e7.svg";